import {
  MATCH_FILTER_KEYS,
  MATCH_FILTER_NAMES,
  SORT_ORDER,
  SORT_TYPES,
} from "../utils/constant";
import { getResponsiveMoment } from "../utils/moments.util";
import paginateUtil from "../utils/paginate.util";

function filterChangesOnly(matches, companyId) {
  if (companyId === false) {
    return matches;
  }

  return matches.filter((match) => Boolean(match.handicapCount) || Boolean(match.totalCount));
}

function mapList(matches, state, favorites) {
  const moment = getResponsiveMoment();

  return matches.map((match) => ({
    ...match,
    isFavorite: favorites.includes(match._id),
    mini: state.expanded.includes(match._id) === false,
    startTime: `${match.start < new Date() ? "delay" : ""} ${moment(match.start).fromNow(true)}`,
    time: moment(match.start),
  }));
}

function filterList(matches, filters, opts) {
  return filters.reduce((acc, filter) => {
    if (typeof filter === "string" && !opts.noTabFilter) {
      return filterMatches(acc, filter);
    } else if (typeof filter === "object" && !opts.noSignalFilter) {
      return filterMatches(acc, filter.type, filter.value);
    } else {
      return acc;
    }
  }, matches);
}

function filterMatches(matches, filter, filterValue) {
  switch (filter) {
    case MATCH_FILTER_KEYS.ALL:
      return matches;
    case MATCH_FILTER_KEYS.FAVORITES:
      return matches.filter((match) => match.isFavorite);
    case MATCH_FILTER_KEYS.SEARCH:
      return filterBySearch(matches, filterValue);
    case MATCH_FILTER_KEYS.CHANGES_ONLY:
      return filterChangesOnly(matches, filterValue);
    default:
      return matches;
  }
}

function filterBySearch(matches, filterValue) {
  if (!filterValue) {
    return matches;
  }

  const searchText = filterValue.toLowerCase();
  return matches.filter(({ home, away, league }) => {
    const names = [home.name, away.name, league];
    return names.some((name = "") => name.toLowerCase().includes(searchText));
  });
}

function sortList(matches, sort, favorite) {
  const { type, order } = sort;

  return [...matches].sort((a, b) => {
    let itemA = favorite.includes(a._id);
    let itemB = favorite.includes(b._id);

    if (itemA !== itemB) {
      return !itemA && itemB ? 1 : -1;
    } else if (type === null || order === null) {
      return a.start - b.start;
    } else {
      switch (type) {
        case SORT_TYPES.TIME:
          itemA = a.start;
          itemB = b.start;
          break;
        case SORT_TYPES.TOTAL:
          itemA = a.totalCount;
          itemB = b.totalCount;
          break;
        case SORT_TYPES.HANDICAP:
          itemA = a.handicapCount;
          itemB = b.handicapCount;
          break;
        default:
          return 0;
      }

      if (itemA === itemB) return 0;
      const sortOrder = itemA > itemB ? -1 : 1;
      if (order === SORT_ORDER.ASC) return sortOrder * -1;
      return sortOrder;
    }
  });
}

export default {
  prematchFilters: (state, getters) => (filters) => {
    const opts = { noTabFilter: true, noSignalFilter: true, noSearch: true };
    const [filterKey] = state.prematch.filters;
    const matches = getters.prematchMatches(opts).data;

    return filters.map((key) => ({
      key,
      name: MATCH_FILTER_NAMES[key],
      isActive: filterKey === key,
      count: filterMatches(matches, key).length,
    }));
  },
  prematchSorting: (state) => (sorting) => {
    const { type, order } = state.prematch.sort;

    return sorting.map((key) => ({
      key,
      name: key,
      isActive: type === key,
      isASC: order === SORT_ORDER.ASC,
      isDESC: order === SORT_ORDER.DESC,
    }));
  },

  prematchMatches: (state) => (opts) => {
    const { matches, filters, sort } = state.prematch;
    const { searchText, favorites } = state.match;

    const mappedList = mapList(matches, state.prematch, favorites);
    const searchedList = filterBySearch(
      mappedList,
      !opts.noSearch ? searchText : "",
    );
    const filteredList = filterList(searchedList, filters, opts);
    const matchList = sortList(filteredList, sort, favorites);

    const total = matchList.length;

    if (opts.page && opts.perPage) {
      return {
        data: paginateUtil.paginateList(matchList, opts.page, opts.perPage),
        total,
      };
    }

    return { data: matchList, total };
  },
};
